/** Nhắc người học còn khảo sát chưa trả lời (TT 83 C9-c) — chỉ học viên + flag bật. */
import { Alert, Button } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { listMySurveys } from "@/features/surveys/api";
import { useAuthStore } from "@/stores/auth";

export function SurveyBanner() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const enabled = user?.role === "student" && !!user?.feature_flags?.surveys;
  const q = useQuery({ queryKey: ["my-surveys"], queryFn: listMySurveys, enabled });
  const n = q.data?.results.length ?? 0;
  if (!enabled || n === 0) return null;
  return (
    <Alert
      type="info"
      showIcon
      message={`Bạn có ${n} phiếu khảo sát cần trả lời`}
      action={
        <Button size="small" type="primary" onClick={() => navigate("/surveys")}>
          Trả lời
        </Button>
      }
    />
  );
}
